import { NameIdPair } from "types/api/nameIdPair";
import { SortOrder } from "types/api/sortOrder";

import { ExportField } from "./api/exportField";
import { PageResponse } from "./pageResponse";
import { FilterInfo } from "./pagination";

export interface AssessmentResponseDto {
  id: number;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  name: string;
  type: string;
  startDate: number;
  endDate: number;
  requestedBy: number;
  status: AssessmentStatusEnum;
  notes?: string | undefined;
  scope: AssessmentScopeResponseDto;
  tagList: Array<string>;
  assessors: number[];
}

type AssessmentScopeResponseDto = {
  product: number;
  subProductIds: Array<number>;
  environmentName: string;
};

export type AssessmentListingResponseDto =
  PageResponse<AssessmentListingContent>;

export type AssessmentListingContent = {
  id: number;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  name: string;
  type: string;
  startDate: number;
  endDate: number;
  requestedBy: number;
  scope: {
    product: number;
    subProductIds: number[];
  };
  tagList: Array<string>;
  status: AssessmentStatusEnum;
  notes?: string;
  tags?: string[];
  publishedFindingsCount?: number;
  draftFindingsCount?: number;
  publishedFindingsBySeverity?: Record<string, number>;
  publishedFindingsByRiskRating?: Record<string, number>;
};

export interface AssessmentCompositeRequestDto {
  name: string;
  type: string;
  startDate: string;
  endDate: string;
  notes?: string;
  scope: AssessmentScopeRequestDto;
  assessors: number[];
  requestedBy: number;
  status: AssessmentStatusEnum;
  tagList: Array<string>;
}

export type AssessmentScopeRequestDto = {
  productId: number;
  subProductIds: number[];
  environmentName: string;
};

export enum AssessmentStatusEnum {
  INPROGRESS = "INPROGRESS",
  COMPLETE = "COMPLETE",
}

export interface AssessmentFiltersRequestDto {
  page?: number;
  size?: number;
  sortColumn?: string;
  sortColumns?: SortOrder[];
  sortOrder?: string;
  filters: FilterInfo;
  exportFields?: ExportField[];
  timezone?: string;
}

export interface AssessmentFilterValues {
  subProduct: Array<NameIdPair>;
  product: Array<NameIdPair>;
  environmentName: string[];
  createdBy: string[];
  name: string[];
  assessors: Array<NameIdPair>;
  type: string[];
  status: string[];
}

export interface AssessmentShortResponseDto {
  data: Array<NameIdPair>;
  success: boolean;
  timestamp: string;
}

export type AssessmentReportRequestDto = {
  assessmentId: number;
  report: string;
  id?: number;
};

export type AssessmentReportResponseDto = {
  assessmentId: number;
  report: string;
  id: number;
};

export type AssessmentExportData = {
  presignedUrl: string;
  key: string;
  mediaType: string;
  fileName: string;
  expirationTime: number;
  message: string | null;
  bucketName: string | null;
};
